import { render } from "./FileDrop.vue?vue&type=template&id=45f15c36&scoped=true&ts=true"
import script from "./FileDrop.vue?vue&type=script&lang=ts"
export * from "./FileDrop.vue?vue&type=script&lang=ts"

import "./FileDrop.vue?vue&type=style&index=0&id=45f15c36&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src678506843/src/babyhead-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f15c36"]])

export default __exports__